import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import InputMask from 'react-input-mask';

const MuiInput = forwardRef(({
  type = 'text',
  name,
  label,
  variant = "outlined",
  disabled = false,
  required = false,
  value,
  onChange,
  InputProps,
  fullWidth,
  onKeyUp,
  onKeyDown,
  onBlur,
  className,
  minRows,
  helperText,
  placeholder,
  mask, // Add the mask prop
  maskChar = 'x', // Optional: Customize the placeholder character
  formatChars, // Optional: Custom format characters
  sx = {},
  style={}
}, ref) => {
  const handleInputChange = (event) => {
    if (InputProps && InputProps.maxLength && event.target.value.length > InputProps.maxLength) {
      return;
    }
    onChange(event); 
  };


  const defaultStyles = {
    width: "100%",
    backgroundColor: "#FFF",
    fontSize: "14px",
    color: "#101010",
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "black", // For WebKit browsers
      backgroundColor: "#d3d3d3"
    },
    ...sx,
  };

  if (mask) {
    return (
      <InputMask
        mask={mask}
        value={value}
        onChange={handleInputChange}
        maskChar={maskChar}
        formatChars={formatChars}
        disabled={disabled} 
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            inputRef={ref}
            fullWidth={fullWidth}
            minRows={minRows}
            type={type}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            label={label}
            name={name}
            className={className}
            variant={variant}
            disabled={disabled}
            required={required}
            InputProps={InputProps}
            onBlur={onBlur}
            sx={defaultStyles}
            style={style}
            helperText={helperText}
            placeholder={placeholder}
            InputLabelProps={{ shrink: !!value || undefined }}
          />
        )}
      </InputMask>
    );
  }
  // console.log("disabled-----", disabled);
  // console.log("required-----", type);


  return (
    <TextField
      inputRef={ref}
      minRows={minRows}
      type={type}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      label={label}
      name={name}
      className={className}
      variant={variant}
      disabled={disabled}
      required={required}
      InputProps={InputProps}
      value={value}
      onChange={handleInputChange}
      onBlur={onBlur}
      sx={defaultStyles}
      style={style}
      helperText={helperText}
      placeholder={placeholder}
      InputLabelProps={{ shrink: !!value || undefined }}
    />
  );
})

export default MuiInput;
